import { Action, Store } from "vuex";
import { namespace, TimeZone } from "../modules/timeZones/timeZones";

export default class TimeZonesStore {
    private store: Store<any>;

    constructor(store: Store<any>) {
        this.store = store;
    }

    /** Gets the timezones */
    public async getTimeZonesAsync(): Promise<TimeZone[]> {
        return await this.store.dispatch(`${namespace}/getTimeZones`);
    }
}
